import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Grid, LinearProgress, Theme, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import ViewProfileOverview from "./ViewProfileOverview";
import RMDetails from "./RMDetails";
import PersonalDetails from "./PersonalDetails";
import RelatedPersonDetails from "./RelatedPersonDetails";
import ContactDetails from "./ContactDetails";
import NonIndividualContactDetails from "../../NonIndividualApplicationDetails/ContactDetails"
import AdditionalKYCDetails from "./AdditionalKYCDetails";
import NomineeDetails from "./NomineeDetails";
import FatcaDetails from "./FatcaDetails";
import BankDetails from "./BankDetails";
import NonIndividualBankDetails from "../../ApplicationDetails/BankDetails";
import RiskProfileDetails from "./RiskProfileDetails";
import InvestmentPreferenceDetails from "./InvestmentPreferenceDetails";
import ServicePreferenceDetails from "./ServicePreferenceDetails";
import { useHistory } from "react-router";
import { getApplicationDetailsByClientCode } from "../../../redux-store/actions/investorProfile";
import DocumentDetails from "./DocumentDetails";
import { RootStateType } from "../../../redux-store/reducers";
import BreadCrum from "../../../lib/BreadCrum";
import { isModuleAllowed, maskInfo } from "../../../utils/utilityFunctions";
import NexEdgeInvPrefDetails from "./NexEdgeInvPrefDetails";
import Consent from "./Consent";
import { APPLICATION_TYPE, PHYSICAL_DIGITAL_FLOW, USER_ROLES } from "../../../utils/constant";
import DistributorDetails from "../../ApplicationDetails/rmDetails";
import ContributorDetails from "../../NonIndividualApplicationDetails/ContributorDetails";
import RelatedPartiesDetails from "../../NonIndividualApplicationDetails/RelatedPartiesDetails";
import Fatca from "../../NonIndividualApplicationDetails/fatca";
import RiskProfile from "../../NonIndividualApplicationDetails/RiskProfile";
import InvPref from "../../NonIndividualApplicationDetails/InvPref";
import Documents from "../../NonIndividualApplicationDetails/Document";
import { ArrowDropDown } from "@mui/icons-material";

function IndividualProfileSections({
    viewProfileData = {}
}: {
    viewProfileData: any
}): JSX.Element {
    return (
        <>
            {PHYSICAL_DIGITAL_FLOW && (
                <Box id="Consent">
                    <Consent overviewData={viewProfileData ?? {}} />
                </Box>
            )}
            <Box id="Overview">
                <ViewProfileOverview overviewData={viewProfileData ?? {}} />
            </Box>
            <Box id="RM Details">
                <RMDetails overviewData={viewProfileData ?? {}} />
            </Box>
            <Box id='Personal Details'>
                <PersonalDetails overviewData={viewProfileData ?? {}} />
            </Box>
            <Box id="Details of Related Person">
                <RelatedPersonDetails overviewData={viewProfileData ?? {}} />
            </Box>
            <Box id='Contact Details'>
                <ContactDetails overviewData={viewProfileData ?? {}} />
            </Box>
            <Box id='Additional KYC'>
                <AdditionalKYCDetails overviewData={viewProfileData ?? {}} />
            </Box>
            <Box id='Nominee Details'>
                <NomineeDetails overviewData={viewProfileData ?? {}} />
            </Box>
            <Box id='FATCA Declaration'>
                <FatcaDetails overviewData={viewProfileData ?? {}} />
            </Box>
            <Box id="Bank Details">
                <BankDetails overviewData={viewProfileData ?? {}} />
            </Box>
            <Box id='Risk Profile'>
                <RiskProfileDetails overviewData={viewProfileData ?? {}} />
            </Box>
            {/* Commented for NexEdge client */}
            {/* <div id='Investment Preference'>
                                    <InvestmentPreferenceDetails overviewData={viewProfileData ?? {}} />
                                </div> */}
            <Box id='Investment Preference'>
                <NexEdgeInvPrefDetails overviewData={viewProfileData ?? {}} />
            </Box>
            {/* <div id='Service Preference'>
                                    <ServicePreferenceDetails overviewData={viewProfileData ?? {}} />
                                </div> */}
            <Box id='Upload Documents'>
                <DocumentDetails overviewData={viewProfileData ?? {}} />
            </Box>
        </>
    )
}

function NonIndividualProfileSections({
    viewProfileData = {}
}: {
    viewProfileData: any
}): JSX.Element {
    return (
        <>
            {PHYSICAL_DIGITAL_FLOW && (
                <Box id="Consent">
                    <Consent overviewData={viewProfileData ?? {}} />
                </Box>
            )}
            <Box id="Distributor Details">
                <DistributorDetails application={viewProfileData ?? {}} hideBseESignStatus />
            </Box>
            <Box id='Contributor Details'>
                <ContributorDetails application={viewProfileData ?? {}} />
            </Box>
            <Box id="Contact Details">
                <NonIndividualContactDetails applicants={viewProfileData?.applicants ?? []} />
            </Box>
            <Box id='Investor’s Bank Details'>
                <NonIndividualBankDetails banks={viewProfileData?.banks ?? []} application={viewProfileData ?? {}} />
            </Box>
            <Box id='Related Parties'>
                <RelatedPartiesDetails application={viewProfileData ?? {}} />
            </Box>
            <Box id='FATCA'>
                <Fatca applicants={viewProfileData?.applicants ?? []} />
            </Box>
            <Box id="Risk Profile">
                <RiskProfile application={viewProfileData ?? {}} />
            </Box>
            <Box id='Investment Preference'>
                <InvPref application={viewProfileData ?? {}} />
            </Box>
            <Box id='Document Details'>
                <Documents application={viewProfileData ?? {}} />
            </Box>
        </>
    )
}

export default function ViewProfile(): JSX.Element {
    const history = useHistory();
    const { state, pathname: pathName } = history.location;
    const [onboardingType, setOnboardingType] = useState<string>('');
    const [applicationType, setApplicationType] = useState<string>('')
    const [loading, setLoading] = useState(false);
    const [viewProfileData, setViewProfileData] = useState();
    const dispatch = useDispatch();
    const [expanded, setExpanded] = useState<string | false>(false);
    const {
        role = '',
        permissions = []
    } = useSelector((store: RootStateType) => store.auth);
    const {
        selectedPortfolio
    } = useSelector((store: RootStateType) => store.selectedPortfiolio);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const clientCode = ((state as any)?.clientCode ?? '') as string;
    // console.log('clientcode', clientCode);

    const fetchViewProfileData = async () => {
        setLoading(true);

        const ans = (await dispatch(getApplicationDetailsByClientCode({
            clientCode: clientCode
        }))) as any;

        const modifiedResponse = {
            ...ans ?? {},
            name: maskInfo(ans?.name ?? ""),
            pan: maskInfo(ans?.pan ?? ""),
            mobile: maskInfo(ans?.mobile ?? ""),
            email: maskInfo(ans?.email ?? ""),
            rm: {
                ...ans?.rm ?? {},
                user: {
                    ...ans?.rm?.user ?? {},
                    email: maskInfo(ans?.rm?.user?.email ?? ""),
                    phone: maskInfo(ans?.rm?.user?.phone ?? ""),
                    firstName: maskInfo(ans?.rm?.user?.firstName ?? ""),
                }
            },
            applicants: (ans?.applicants ?? [])?.map((ele: any) => ({
                ...ele,
                firstName: maskInfo(ele?.firstName ?? ""),
                lastName: maskInfo(ele?.lastName ?? ""),
                panNo: maskInfo(ele?.panNo ?? ""),
                email: maskInfo(ele?.email ?? ""),
                mobile: maskInfo(ele?.mobile ?? ""),
                kraMobileNumber: maskInfo(ele?.kraMobileNumber ?? ""),
            })) ?? [],
            banks: (ans?.banks ?? []).map((ele: any) => ({
                ...ele,
                bankAccountNumber: maskInfo(ele?.bankAccountNumber ?? ""),
                ifscCode: maskInfo(ele?.ifscCode ?? ""),
                micrCode: maskInfo(ele?.micrCode ?? ""),
            })) ?? [],
        }

        setOnboardingType(modifiedResponse?.onboardingType ?? "");
        setApplicationType(modifiedResponse?.applicationType ?? "");

        setViewProfileData(modifiedResponse);
        setLoading(false);

    }
    useEffect(() => {
        fetchViewProfileData();

    }, [])

    const initialRouter = pathName.split('/').filter((item) => item !== '')
    const rmRouterPath = (isModuleAllowed({ value: "MFDashboard", compareArr: permissions, objKey: "permissonCode" }) ? [
        {
            name: 'Dashboard',
            path: '/dashboard',
            // warning: true
        },
        {
            name: `${initialRouter[1]}`,
            path: `/${initialRouter[0]}/${initialRouter[1]}`,
            state: {
                clientCode: clientCode || ""
            }
        },
        {
            name: 'View Profile',
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}`,
            state: {
                clientCode: clientCode || ""
            }
        }
    ] : [])

    const investorRouterPath = [
        {
            name: `Dashboard`,
            path: '/investor-dashboard',
            // warning: true
        },
        {
            name: 'View Profile',
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}`,
            state: {
                clientCode: clientCode || ""
            }
        }
    ]

    const individualProfileHeaders = [
        'Overview',
        'RM Details',
        "Personal Details",
        "Details of Related Person",
        "Contact Details",
        "Additional KYC",
        "Nominee Details",
        "FATCA Declaration",
        "Bank Details",
        "Risk Profile",
        "Investment Preference",
        // "Service Preference",
        "Upload Documents"
    ]

    const nonIndividualProfileHeaders = [
        "Distributor Details",
        "Contributor Details",
        "Contact Details",
        "Investor’s Bank Details",
        "Related Parties",
        "FATCA",
        "Risk Profile",
        "Investment Preference",
        "Document Details"
    ]

    const viewProfileHeaders = [
        ...(PHYSICAL_DIGITAL_FLOW ? ['Consent'] : []),
        ...(
            `${applicationType ?? ""}`.toLowerCase() === APPLICATION_TYPE.INDIVIDUAL ? individualProfileHeaders : nonIndividualProfileHeaders
        )
    ]

    const scrollToContent = (id: string) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const [activeHeader, setActiveHeader] = useState(viewProfileHeaders[0]);

    const handleAccordionChange = (panel: string) => (
        event: React.SyntheticEvent,
        isExpanded: boolean
    ) => {
        setExpanded(isExpanded ? panel : false);
    };


    const handleHeaderClick = (header: string) => {
        setExpanded(false);

        setActiveHeader(header);
        scrollToContent(header);
    };



    return (
        <>
            {loading ? <LinearProgress /> : <Box>

                <Box sx={{ width: '100%' }}>
                    <BreadCrum array={![USER_ROLES.INVESTOR].includes(role) ? rmRouterPath : investorRouterPath} />
                </Box>
                {/* Main Data */}
                <Box sx={(theme: Theme) => ({
                    p: "35px 35px 35px 25px",
                    border: `1px solid ${theme.palette.text.secondary}26`,
                    borderRadius: "15px",
                    background: theme.palette.background.paper,
                    mt: '20px'
                })}>
                    <Grid container columnSpacing={'15px'} >
                        <Grid
                            item
                            xs={12}
                            md={4}
                            lg={3}
                            sx={{
                                padding: 0,
                                position: 'sticky',
                                top: '0',
                                height: 'calc(100vh + 60px)',
                                display: { xs: "none", md: "block" }
                            }}
                        >
                            <Box sx={{ width: '100%', mt: '25px', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start' }}>
                                {viewProfileHeaders.map((header: string, index: number) => (
                                    <Button
                                        key={index}
                                        onClick={() => {
                                            setActiveHeader(header);
                                            scrollToContent(header);
                                        }}
                                        sx={(theme: Theme) => (
                                            {
                                                mt: index !== 0 ? '15px' : 0,
                                                backgroundColor: activeHeader === header ? theme.palette.primary[500] : theme.palette.common.white,
                                                borderRadius: '8px',
                                                padding: '10px 20px ',
                                                width: '100%',
                                                alignItems: 'flex-start',
                                                justifyContent: 'flex-start',
                                                alignSelf: 'flex-start',
                                                justifySelf: 'flex-start',
                                                textAlign: 'left',
                                                textTransform: 'none'
                                            })}
                                        aria-label={header}
                                        role="link"
                                    >
                                        <Typography component={'span'} variant="body_500"
                                            sx={() => ({
                                                color: activeHeader === header ? 'textDark.primary' : 'text.secondary',
                                                cursor: 'pointer',
                                                width: '100%',
                                                display: 'block',
                                                textAlign: 'left'
                                            })}
                                        >{header}</Typography>
                                    </Button>
                                ))}
                            </Box>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={4}
                            lg={3}
                            sx={{ display: { xs: 'block', md: 'none' }, paddingBottom: 2 }}
                        >
                            <Accordion
                                expanded={expanded === 'panel1a'}
                                onChange={handleAccordionChange('panel1a')}
                                sx={{
                                    boxShadow: 'none',
                                    '&:before': {
                                        display: 'none',
                                    },
                                }}
                            >
                                <AccordionSummary
                                    // expandIcon={<ArrowDropDown />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                    sx={{
                                        padding: 0,
                                    }}
                                ><Box
                                    sx={(theme) => ({
                                        backgroundColor: theme.palette.primary[50],
                                        border: `1px solid ${theme.palette.primary[500]}`,
                                        borderRadius: '8px',
                                        padding: '10px 20px',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        width: '100%',
                                        alignItems: 'center'
                                    })}
                                >
                                        <Typography
                                            component="span"
                                            variant="body_500"
                                            // onClick={() => handleHeaderClick(activeHeader)}
                                            sx={(theme) => ({
                                                color: theme.palette.primary[500],
                                                cursor: 'pointer',
                                            })}
                                        >
                                            {activeHeader}
                                        </Typography>
                                        <ArrowDropDown
                                            sx={(theme) => ({
                                                color: theme.palette.primary[500],
                                                transition: 'transform 0.3s ease-in-out',
                                                transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)'
                                            })}
                                        />
                                    </Box>
                                </AccordionSummary>
                                <AccordionDetails
                                    sx={(theme) => ({
                                        paddingX: 1,
                                        paddingY: 2,
                                        border: `1px solid ${theme.palette.text.secondary}26`,
                                        borderRadius: 3
                                    })}
                                >
                                    <Box>
                                        {viewProfileHeaders.map((header, index) => (
                                            <Button
                                                key={index}
                                                sx={(theme) => ({
                                                    mt: index !== 0 ? '15px' : 0,
                                                    backgroundColor:
                                                        activeHeader === header
                                                            ? theme.palette.primary[500]
                                                            : theme.palette.common.white,
                                                    borderRadius: '8px',
                                                    padding: '10px 20px',
                                                    textAlign: 'left',
                                                    width: '100%'
                                                })}
                                                aria-label={header}
                                                onClick={() => handleHeaderClick(header)}
                                            >
                                                <Typography
                                                    component="span"
                                                    variant="body_500"
                                                    sx={(theme) => ({
                                                        color:
                                                            activeHeader === header
                                                                ? theme.palette.textDark?.primary ?? theme.palette.text.primary
                                                                : theme.palette.text.secondary,
                                                        cursor: 'pointer',
                                                        textAlign: 'left',
                                                        width: '100%'
                                                    })}
                                                >
                                                    {header}
                                                </Typography>
                                            </Button>
                                        ))}
                                    </Box>
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                        <Grid item
                            container
                            xs={12}
                            md={8}
                            lg={9}
                        >
                            <Box component={'div'} sx={(theme: Theme) => ({ padding: '35px', border: `1px solid ${theme.palette.text.secondary}26`, borderRadius: '15px', backgroundColor: `${theme.palette.common.white}`, width: '100%' })}>
                                {
                                    (`${applicationType ?? ""}`.toLowerCase() === APPLICATION_TYPE.INDIVIDUAL) ? (
                                        <IndividualProfileSections
                                            viewProfileData={viewProfileData} />
                                    ) : (
                                        <NonIndividualProfileSections
                                            viewProfileData={viewProfileData} />
                                    )
                                }

                            </Box>

                        </Grid>
                    </Grid>

                </Box>
            </Box>}
        </>
    )
}
